import { Icon } from "@iconify/react";

export type DocumentFilePresentation = {
  extension: string;
  icon: string;
  surfaceClassName: string;
  iconClassName: string;
  badgeClassName: string;
};

export function getDocumentFilePresentation(
  fileName: string
): DocumentFilePresentation {
  const finalDotIndex = fileName.lastIndexOf(".");
  const extension =
    finalDotIndex > 0 && finalDotIndex < fileName.length - 1
      ? fileName.slice(finalDotIndex + 1).toLowerCase()
      : "";
  const label = extension ? extension.toUpperCase() : "FILE";

  if (extension === "pdf") {
    return {
      extension: label,
      icon: "mdi:file-pdf-box",
      surfaceClassName: "bg-red-50",
      iconClassName: "text-red-600",
      badgeClassName: "bg-red-50 text-red-700",
    };
  }
  if (extension === "doc" || extension === "docx") {
    return {
      extension: label,
      icon: "mdi:file-word-outline",
      surfaceClassName: "bg-blue-50",
      iconClassName: "text-blue-600",
      badgeClassName: "bg-blue-50 text-blue-700",
    };
  }
  if (
    extension === "xls" ||
    extension === "xlsx" ||
    extension === "xlsm" ||
    extension === "csv"
  ) {
    return {
      extension: label,
      icon: "mdi:file-excel-outline",
      surfaceClassName: "bg-green-50",
      iconClassName: "text-green-600",
      badgeClassName: "bg-green-50 text-green-700",
    };
  }
  if (extension === "ppt" || extension === "pptx") {
    return {
      extension: label,
      icon: "mdi:file-powerpoint-outline",
      surfaceClassName: "bg-orange-50",
      iconClassName: "text-orange-600",
      badgeClassName: "bg-orange-50 text-orange-700",
    };
  }
  if (["gif", "jpeg", "jpg", "png", "webp"].includes(extension)) {
    return {
      extension: label,
      icon: "mdi:file-image-outline",
      surfaceClassName: "bg-purple-50",
      iconClassName: "text-purple-600",
      badgeClassName: "bg-purple-50 text-purple-700",
    };
  }
  if (extension === "txt") {
    return {
      extension: label,
      icon: "mdi:file-document-outline",
      surfaceClassName: "bg-stone-100",
      iconClassName: "text-stone-500",
      badgeClassName: "bg-stone-100 text-stone-600",
    };
  }
  return {
    extension: label,
    icon: "mdi:file-outline",
    surfaceClassName: "bg-stone-100",
    iconClassName: "text-stone-500",
    badgeClassName: "bg-stone-100 text-stone-600",
  };
}

interface DocumentFileTypeIconProps {
  fileName: string;
  className?: string;
  size?: number;
}

export default function DocumentFileTypeIcon({
  fileName,
  className = "",
  size = 20,
}: DocumentFileTypeIconProps) {
  const presentation = getDocumentFilePresentation(fileName);
  return (
    <Icon
      aria-hidden="true"
      icon={presentation.icon}
      height={size}
      className={`${presentation.iconClassName} ${className}`}
    />
  );
}
